import { db } from './common'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'

let emptyMap = {}
let entities = R.mapObjIndexed(
	(_, entity) => state => (state.data.idx && state.data.idx[entity]) || emptyMap
  , {
		'agent': 1
	  , 'application': 1
	  , 'attachment': 1
	  , 'comment': 1
	  , 'lease': 1
	  , 'listing': 1
	  , 'manager': 1
	  , 'merchant': 1
	  , 'notification': 1
	  , 'owner': 1
	  , 'project': 1
	  , 'property': 1
	  , 'property-history': 1
	  , 'repairman': 1
	  , 'system': 1
	  , 'task': 1
	  , 'template': 1
	  , 'tenant': 1
	  , 'term': 1
  	, 'transaction/bad-debt': 1
	  , 'transaction/bill': 1
	  , 'transaction/credit': 1
  	, 'transaction/deposit-use': 1
  	, 'transaction/deposit-refund': 1
	  , 'transaction/invoice': 1
	  , 'transaction/invoice-payment': 1
  	, 'transaction/refund': 1
		, 'property-history': 1
	}
)

export let transactions = createSelector(
	R.values(R.pickBy((v, k) => k.indexOf('transaction/') === 0, entities))
  , (...rest) => {
  		let a = rest
  		console.log('transactions', a)
  		let x = R.mergeAll(rest)
  		return x
  	}
)
entities.transaction = transactions

export let vendors = createSelector(
	[entities.agent, entities.merchant, entities.repairman]
  , (agent, merchant, repairman) => {
		return {...agent, ...merchant, ...repairman}
	}
)
entities.vendor = vendors

export let leasesOnly = createSelector(
	[entities.lease]
  , R.filter(x => !x.parentID)
)
entities['leaseOnly'] = leasesOnly

export let terms = createSelector(
	[entities.lease]
  , R.filter(x => x.parentID)
)
entities['terms'] = terms

export default entities

export let arrays = R.map(x => createSelector(x, R.values), entities)

export let merchants = entities['merchant']
export let tenants = entities['tenant']
export let templates = entities['template']
export let managers = entities['manager']
export let listings = entities['listing']
export let leases = entities['lease']
export let projects = entities['project']
export let tasks = entities['task']
export let properties = entities['property']
export let repairmen = entities['repairman']
export let agents = entities['agent']
export let owners = entities['owner']
export let quotes = entities['quote']
export let bills = entities['transaction/bill']
export let invoices = entities['transaction/invoice']
export let payments = entities['transaction/invoice-payment']
export let credits = entities['transaction/credit']
export let refunds = entities['transaction/refund']
export let depositsuse = entities['transaction/deposit-use']
export let depositsrefund = entities['transaction/deposit-refund']
export let badDebts = entities['transaction/bad-debt']
export let comments = entities['comment']
export let historyPrice = entities['property-history']

// TODO: why arrays?
export let attachments = arrays['attachment']
export let notifications = arrays['notification']
export let applications = arrays['application']



// WEBPACK FOOTER //
// ./src/selectors/entities.js